import React from 'react'
import { Route, Switch } from 'react-router-dom'
import routes from '../../routes'
import { CategorySelection } from './CategorySelection'
import { Day1Slides } from './Slides/Day1Slides'
import { UpcomingEvent } from './UpcomingEvents'
import { Day2Slides } from './Slides/Day2Slides'
import { Day1Videos } from './Day1Videos'
import { Day2Videos } from './Day2Videos'

export default function OnDemandPage() {
  return (
    <>
      <Switch>
        {/* <Route exact path={routes.onDemand} render={(props) => <CategorySelection {...props} />} /> */}
        <Route exact path={routes.onDemand} render={(props) => <Day1Videos {...props} />} />
        <Route exact path={routes.onDemandDay1} render={(props) => <Day1Slides {...props} />} />
        <Route exact path={routes.onDemandDay2} render={(props) => <Day2Slides {...props} />} />
        <Route exact path={routes.onDemandUpcomingEvents} render={(props) => <UpcomingEvent {...props} />} />
        <Route exact path={routes.galleryDay1Videos} render={(props) => <Day1Videos {...props} />} />
        <Route exact path={routes.galleryDay2Videos} render={(props) => <Day2Videos {...props} />} />
        {/* <Route exact path={routes.onDemandBbs} render={(props) => <BestBasicScience {...props} />} />
        <Route exact path={routes.onDemandPoster} render={(props) => <AreaOfInterestSelection {...props} />} />
        <Route exact path={routes.onDemandOral} render={(props) => <AreaOfInterestSelection {...props} />} />
        <Route
          exact
          path="/on-demand/:category"
          render={(props) => <CategoryContent {...props} category={onDemandCategories.find((category) => category.destination === props.location.pathname)} />}
        />

        <Route exact path="/on-demand/e-poster-presentations/:areaOfInterest" render={(props) => <PosterAbstractList {...props} />} />
        <Route exact path="/on-demand/oral-presentations/:areaOfInterest" render={(props) => <OralAbstractList {...props} />} />

        <Route exact path="/on-demand/abstracts/:abstractId" render={(props) => <PresentationContainer {...props} />} /> */}
      </Switch>
    </>
  )
}
